import Cookies from 'js-cookie';
import CryptoJS from "crypto-js";

const SECRET_KEY = "dmhfwvcghhiwegh874637v4gf"; // Replace with a secure key
export const getCookie = (name) => {
  const cookieValue = Cookies.get(name, { domain: '.neetsupport.com' }) || null;
  return cookieValue;
};
export const decryptData = (encryptedData) => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("Error decrypting data:", error);
    return null;
  }
}
export const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, SECRET_KEY).toString();
};